import { render, staticRenderFns } from "./PubchemReport.vue?vue&type=template&id=d1fba084"
import script from "./PubchemReport.vue?vue&type=script&lang=js"
export * from "./PubchemReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports